import React, { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Card, Typography, TextField, Box } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);
const PaymentMethodMRT = () => {
  const token = localStorage.getItem("token");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [chart, setChart] = useState({ labels: [], values: [] });

  useEffect(() => {
    axios
      .get("https://portaldata.jaktraffic.my.id/pqs/mrtj/view", {
        params: { token, dt: date, lim: 50000, pg: 1 },
      })
      .then((res) => {
        const map = {};
        res.data.Data.forEach((d) => {
          map[d.metode_pembayaran] = (map[d.metode_pembayaran] || 0) + 1;
        });
        setChart({ labels: Object.keys(map), values: Object.values(map) });
      });
  }, [date]);
  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 4,
        width: "100%",
        height: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
          Metode Pembayaran
        </Typography>
        <TextField
          type="date"
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </Box>
      <Box
        sx={{
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: 360,   // 🔑 INI KUNCI
    mx: "auto",
  }}
      >
        <Doughnut
          data={{
            labels: chart.labels,
            datasets: [
              {
                data: chart.values,
                backgroundColor: ["#42a5f5", "#66bb6a", "#ffa726", "#ab47bc"],
                radius: "85%",
                cutout: "60%",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            layout: {
              padding: 12,
            },
            plugins: {
              legend: {
                position: "top",
                labels: {
                  boxWidth: 12,
                  padding: 10,
                  font: { size: 12 },
                },
              },
            },
          }}
        />
      </Box>
    </Card>
  );
};
export default PaymentMethodMRT;
